module.exports = __webpack_public_path__ + "494302f4d22fe0aae6d688d9a9c966d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/iconfont/iconfont.svg
// module id = 354
// module chunks = 0 204 209